// Stub — session timeout not used in hr-admin
import { useAuthStore } from "@/stores/auth";
import { useRouter } from "vue-router";

export const useSessionTimeout = () => {
  const logout = async () => {
    const auth = useAuthStore();
    const router = useRouter();
    await auth.signOut();
    await router.push({ name: "login" });
  };

  return {
    logout,
    initializeSessionTimeout: () => {},
    cleanup: () => {},
  };
};
